<app-menu class="menuApp" xmlns="http://www.w3.org/1999/html"></app-menu>
<div class="main">
  <div style="width: 90%; margin: auto;">

    <div class="row reglaSection">
      <div class="reglaHeader">
        <span (click)="toAirfal()" class="material-icons-outlined centerVert textL infoContactButton">chevron_left</span>
        <h1 class="centerVert textM" style="width: 90%; top: 65%">{{contacto.titulo}}</h1>
        <span *ngIf="!expand" (click)="changeExpand()" class="material-icons-outlined centerVert textL infoContactButton">expand_more</span>
        <span *ngIf="expand" (click)="changeExpand()" class="material-icons-outlined centerVert textL infoContactButton">expand_less</span>
      </div>
      <div *ngIf="expand" class="infoContact">
        <table style="width:100%">
          <tr class="bottom-border">
            <th *ngIf="contacto.estado == 'Abierto'" class="textS">
              {{this.localiser.get('contact.state')}}: {{this.localiser.get('contact.stateOpen')}}
            </th>
            <th *ngIf="contacto.estado == 'Cerrado'" class="textS">
              {{this.localiser.get('contact.state')}}: {{this.localiser.get('contact.stateClose')}}
            </th>
            <th *ngIf="contacto.prioridad == 'Consulta'" class="textS">
              {{this.localiser.get('contact.priority')}}: {{this.localiser.get('contact.query')}}
            </th>
            <th *ngIf="contacto.prioridad == 'Prioritario'" class="textS">
              {{this.localiser.get('contact.priority')}}: {{this.localiser.get('contact.high-priority')}}
            </th>
            <th class="textS">{{this.localiser.get('contact.date')}}: {{getStringTime(contacto.date)}}</th>
            <th class="textS" *ngIf="this.user.getIdContacto() != '0'">{{this.localiser.get('contact.openBy')}}: {{contacto.nombreUsuario}}</th>
            <th class="textS" *ngIf="this.user.getIdContacto() != '0'">{{this.localiser.get('contact.situation')}}: {{contacto.situacion}}</th>
          </tr>
        </table>
        <h3 class="textS" style="text-align: justify">
          <b>{{this.localiser.get('contact.description')}}:</b> {{contacto.descripcion}}
        </h3>
      </div>
      <div class="reglaTable">

        <div *ngFor="let mensaje of contactoMensajes">
          <div *ngIf="mensaje.idUsuario == this.user.getId()">
            <h3 class="textS messageByUser">
              <b>{{getStringTimeHour(mensaje.date)}}</b>
              <br>
              {{mensaje.mensaje}}
            </h3>
          </div>
          <div *ngIf="mensaje.idUsuario != this.user.getId()">
            <h3 class="textS messageNoByUser">
              <b>{{mensaje.nombreUsuario}} - {{getStringTimeHour(mensaje.date)}}</b>
              <br>
              {{mensaje.mensaje}}
            </h3>
          </div>
        </div>

      </div>
      <div class="inputMensajeDiv">
        <div class="row" style="margin: auto">
              <textarea [(ngModel)]="mensaje" class="inputMensaje textS" maxlength="250"
                        placeholder="{{this.localiser.get('contact.placeHolderMessage')}}"></textarea>
        </div>
        <div class="row" style="text-align: center; margin: auto">
          <button (click)="newMensaje()" class="buttonSend">{{this.localiser.get('contact.buttonSendMessage')}}</button>
          <button *ngIf="this.user.getIdContacto() != '0'" (click)="closeContacto()" class="buttonSend textS">
            {{this.localiser.get('contact.buttonClose')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
